import PropTypes from 'prop-types';
import stylePropType from './stylePropType';

const stylesPropType = PropTypes.objectOf(stylePropType);

export default stylesPropType;
